import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import clsx from "clsx";

function MobileCardBlock({
  activeMediaSize,
  id,
  activeHallId,
  title,
  setActiveHallId,
  image,
  imageTitleEnabled,
}) {
  return (
    <div
      className={
        activeMediaSize
          ? `club-halls-mob__wrapper card-media-size-${activeMediaSize.count} `
          : "club-halls-mob__wrapper"
      }
    >
      <div
        onClick={() => {
          setActiveHallId(+id);
        }}
        className={clsx("club-halls-mob__block", {
          "club-halls-mob__block_active": id == activeHallId,
          "club-halls-mob__block--blackout-off": !imageTitleEnabled,
        })}
      >
        {image && (
          <Image
            className="club-halls-mob__img"
            src={image}
            fill
            alt="club-img"
          />
        )}
        {imageTitleEnabled && (
          <div className="club-halls-mob__title">
            <span>{title}</span>
          </div>
        )}
      </div>
    </div>
  );
}

MobileCardBlock.propTypes = {
  activeMediaSize: PropTypes.object,
  activeHallId: PropTypes.number,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setActiveHallId: PropTypes.func,
  title: PropTypes.string,
};

MobileCardBlock.defaultProps = {
  activeMediaSize: {},
  activeHallId: -1,
  id: null,
  setActiveHallId: () => {},
  title: "",
};

export default MobileCardBlock;
